import { MqttDingtianService } from "@/views/loyalty/shared/services/mqtt-dingtian-service"
import { ActionCommandEnum, ActionConditionEnum } from "@/views/loyalty/models/justpay-configuration.model"

export class RelayHandler {
    constructor (configuration) {
        console.log('RelayHandler configuration', configuration)
        this.activeAction = {}
        this.activeScenarioId = ''
        this.actionTimerId = 0
        this.configuration = configuration
        this._currentScreen = {}
        this.dingtianService = new MqttDingtianService()
        this._needToCloseScenario = false
        this.planogramm = this.configuration.planogramm
        this.releScenarios = this.configuration.releScenarios
        this.requestDuration = 5
        this.relaySerialNumber = ''
        this._showRelayScreen = false
        this.timerId = 0
        this.timerPageId = 0
        this.scenarioDuration = 0
    }

    async doPage () {
        console.log('RelayHandler doPage')
        const currentScenario = this.releScenarios.find(f => f.scenarioId === this.activeScenarioId)
        const allTimeout = currentScenario.releConf.pages.reduce((a, c) => a + +c.timeout, 0)
        console.log('allTimeout', allTimeout)
        // setTimeout(this.closeScenario, allTimeout * 1000, this)
        console.log('RelayHandler scenario...')
        for (const page of currentScenario.releConf.pages) {
            console.log('this.scenarioDuration', page.timeout)
            this._currentScreen = page.screen
            console.log('this.doAction.call..')
            this.doAction.call(this, page)
            await this.sleep(page.timeout)
        }
        console.log(' ##### end doPage')
        this._needToCloseScenario = true // to close scenario after all actions
    }

    doAction (page) {
        console.log('RelayHandler doAction')
        page.actions.forEach(async action => {
            console.log('RelayHandler doAction action.command_type=', action.command_type)
            if (action.command_type === ActionCommandEnum.NoCommand) {

            }
            if (action.command_type === ActionCommandEnum.RequestRelay) {
                await this.sleep(action.before_timeout)
                console.log('RelayHandler doAction startScanRelayState')
                // command
               await this.sendCommand.apply(this, [action])
                await this.sleep(action.after_timeout)
            }
            if (action.command_type === ActionCommandEnum.ShowMainScreen && action.condition.type === ActionConditionEnum.RelayValue) {
                console.log('RelayHandler doAction ActionCommandEnum.ShowMainScreen')
                this.timerId = setInterval(this.startScanRelayState, this.requestDuration * 1000, this, action.condition.number) // to scan the state of relay
                setTimeout(this.stopScanRelayState, page.timeout * 1000, this.timerId) // to stop the scanning in this.timeout seconds
            }
        })
    }

    closeScenario (that) {
        console.log('!!! Close scenario')
        that._needToCloseScenario = true
    }

    async isChannelBusy (channelNumber) {
        let isBusy = false
        // to check all chain of relay channels belongs to page
        console.log('isChannelBusy channel', channelNumber)
        isBusy = await this.dingtianService.getStatus(this.relaySerialNumber, channelNumber)
        if (isBusy) {
            return isBusy
        }
        return isBusy
    }
    // scenarioId - scenario ID

    // check first channel of relay in chain of channels  belongs to the scenario
    async isRelayBusy (scenarioId) {
        console.log('this.configuration.releScenarios', this.configuration.releScenarios)
        let isBusy = false
        const relayScenario = this.configuration.releScenarios.find(f => f.scenarioId === scenarioId)
        const channelNumber = relayScenario.releConf.pages[0].actions[0].command.number // channelNumber of relay
        // to check all chain of relay channels belongs to page
        for (const page of relayScenario.releConf.pages) {
            for (const action of page.actions) {
                console.log('isRelayBusy channel', channelNumber)
                isBusy = await this.dingtianService.getStatus(this.relaySerialNumber, channelNumber)
                if (isBusy) {
                    return isBusy
                }
            }
        }
        return isBusy
    }

    getCurrentRelayScreen (scenarioId) {
        const relayScenario = this.configuration.releScenarios.find(f => f.scenarioId === scenarioId)
        return relayScenario.releConf.pages[0].screen // current relay screen
    }

    async sendCommand (action) {
        console.log(`send command -> action.command.number=${action.command.number}, action.command.time=${action.command.time}, action.command.type=${action.command.type}, action.command.value= ${action.command.value}`)
        await this.dingtianService.sendMessage(this.relaySerialNumber, action.command.number, action.command.time)
    }

    sleep (sec) {
        return new Promise(resolve => setTimeout(resolve, sec * 1000))
    }

    stopAction (actionTimerId) {
        clearInterval(actionTimerId)
        console.log('**** actionTimerId is closed')
    }

    async startScanRelayState (that, channelNumber) {
        // await that.sleep(2000)
        const isChannelBusy = await that.isChannelBusy.apply(that, [channelNumber])
        console.log('~~~~~~~ scanning relay state....')
        console.log('isChannelBusy=', isChannelBusy)
        that.showRelayScreen = isChannelBusy
    }

    stopScanRelayState (timerId) {
        clearInterval(timerId)
        console.log('**** timerId is closed')
    }

    /// ///// properties
    get currentScreen () {
        console.log('@@@@ current screen')
        return this._currentScreen
    }

    get needToCloseScenario () {
        console.log('!!! return this._needToCloseScenario')
        return this._needToCloseScenario
    }

    set scenarioId (scenarioId) {
        this.activeScenarioId = scenarioId
    }

    set relayNumber (number) {
        this.relaySerialNumber = number
    }

    get viewRelayScreen () {
        return this._showRelayScreen
    }
}
